import { render } from "./InstructorsApp.vue?vue&type=template&id=e0052c5c&scoped=true"
import script from "./InstructorsApp.vue?vue&type=script&lang=js"
export * from "./InstructorsApp.vue?vue&type=script&lang=js"

import "./InstructorsApp.vue?vue&type=style&index=0&id=e0052c5c&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0052c5c"]])

export default __exports__